import React from 'react';
import { observer } from 'mobx-react';
import { Link } from 'react-router';

// Translations
import translate from '../Translate.js';

// Dependencies
import moment from 'moment';
import currencyFormatter from 'currency-formatter';
import { FeatureFlag } from 'react-launch-darkly';

const FundingRulesList = observer(class FundingRulesList extends React.Component {
  constructor() {
    super();

    // Bind this to functions
    this.handleSelect = this.handleSelect.bind(this);
    this.checkSelectTHRender = this.checkSelectTHRender.bind(this);
  }

  componentWillMount() {
    const { query } = this.props.routing.location;

    this.state = {
      selectedRows: [],
      showDetails: [],
      scope: null
    };

    if(query.fundingRuleScope && query.scopeSid) {
      this.getFilteredFundingRules(query.fundingRuleScope, query.scopeSid);

      this.setState({
        scope: query.fundingRuleScope
      });
    } else if(this.props.offeringSid) {
      this.getFilteredFundingRules('courseOfferingSid', this.props.offeringSid);

      this.setState({
        scope: 'courseOfferingSid'
      });
    } else {
      this.getFundingRules();

      this.setState({
        scope: 'installSid'
      });
    }
  }

  getFilteredFundingRules(scope, sid) {
    this.props.store.FundingRuleStore.getFilteredFundingRules(scope, sid);
  }

  getFundingRules() {
    this.props.store.FundingRuleStore.getFundingRules(true);
  }

  toggleDetails(sid) {
    let showDetails = [...this.state.showDetails];
    const sidIndex = showDetails.indexOf(sid);

    if(sidIndex >= 0) {
      showDetails.splice(sidIndex, 1);
    } else {
      showDetails.push(sid);
    }

    this.setState({
      showDetails
    });
  }

  handleEdit(e, fundingRuleSid) {
    e.preventDefault();

    // Update url
    if(!this.props.drawer) {
      let path = e.target.href.replace(/^(?:\/\/|[^\/]+)*\//, '').replace('#', '');

      if(this.props.routing.location.pathname !== path) {
        this.props.routing.push(path);
      }
    } else {
      this.props.parent.setState({
        drawerContent: 'AddFundingRule',
        fundingRuleSid
      })
    }
  }

  handleSelect(e, sid) {
    let selectedRows = [...this.props.selectedRows];
    let rowIndex = -1;

    if(e.target.checked) {
      selectedRows.push(sid);
    } else {
      rowIndex = selectedRows.indexOf(sid);
      selectedRows.splice(rowIndex, 1);
    }

    this.props.parent.setState({
      selectedRows
    });
  }

  renderEdit(key) {
    return (
      <Link
        to={`/funding-rules/edit/${key.sid}`}
        onClick={(e) => {this.handleEdit(e, key.sid)}}
        title={`Edit ${key.title}`}
      >
        {key.title}
      </Link>
    )
  }

  checkEditRender(key) {
    if(this.state.scope !== 'installSid') {
      return (
        <Link
          to={`/funding-rules/edit/${key.sid}`}
          onClick={(e) => {this.handleEdit(e, key.sid)}}
          title={`Edit ${key.title}`}
        >
          {key.title}
        </Link>
      )
    } else {
      return (
        <span>{key.title}</span>
      )
    }
  }

  renderSelectTH() {
    return (
      <th id="heading-select" scope="col">
        <span className="meta">Select</span>
      </th>
    )
  }

  checkSelectTHRender() {
    if(this.state.scope !== 'installSid') {
      return (
        <th id="heading-select" scope="col">
          <span className="meta">Select</span>
        </th>
      )
    }

    return null;
  }

  renderSelectTD(key) {
    return (
      <td className="check-col" aria-labelledby="heading-select">
        <input
          id={`select-${key.sid}`}
          className="checkbox-input"
          type="checkbox"
          onChange={(e) => this.handleSelect(e, key.sid)}
        />

        <label
          className="checkbox-label checkbox-label--solo" htmlFor={`select-${key.sid}`}
        >
          <span className="meta">Select {key.title}</span>
        </label>
      </td>
    )
  }

  checkSelectTDRender(key) {
    if(this.state.scope !== 'installSid') {
      return (
        <td className="check-col" aria-labelledby="heading-select">
          <input
            id={`select-${key.sid}`}
            className="checkbox-input"
            type="checkbox"
            onChange={(e) => this.handleSelect(e, key.sid)}
          />

          <label
            className="checkbox-label checkbox-label--solo" htmlFor={`select-${key.sid}`}
          >
            <span className="meta">Select {key.title}</span>
          </label>
        </td>
      )
    }

    return null;
  }

  render() {
    const { translation } = this.props;
    const { FundingRuleStore, SessionStore } = this.props.store;
    const { userTimezone } = this.props.store.SessionStore;

    if(!FundingRuleStore.fundingRules.length && !SessionStore.loading) {
      return (
        <span className="no-results">{translation.no_results}</span>
      )
    } else if(FundingRuleStore.fundingRules.length > 0) {
      if((this.props.drawer && !SessionStore.loading) || !this.props.drawer) {
        return (
          <table>
            <thead>
              <tr>
                <FeatureFlag
                  flagKey="global-funding-rules"
                  renderFeatureCallback={this.renderSelectTH}
                  renderDefaultCallback={this.checkSelectTHRender}
                />
                <th id="heading-name" className="subtitle" scope="col">
                  {translation.name}
                </th>
                <th id="heading-amount" className="subtitle number" scope="col">
                  {translation.amount}
                </th>
                <th id="heading-applies" className="subtitle" scope="col">
                  {translation.applies_to}
                </th>
                <th id="heading-starts" className="subtitle number" scope="col">
                  {translation.starts}
                </th>
                <th id="heading-ends" className="subtitle number" scope="col">
                  {translation.ends}
                </th>
              </tr>
            </thead>
            <tbody>
              {FundingRuleStore.fundingRules.map(
                (key, i) => {
                  return ([
                    <tr
                      className={
                        this.props.selectedRows.indexOf(key.sid) >= 0 ? 'selected' : ''
                      }
                      key={i}
                    >
                      <FeatureFlag
                        flagKey="global-funding-rules"
                        renderFeatureCallback={() => this.renderSelectTD(key)}
                        renderDefaultCallback={() => this.checkSelectTDRender(key)}
                      />
                      <td aria-labelledby="heading-name">
                        <div className="cell-wrap">
                          <FeatureFlag
                            flagKey="global-funding-rules"
                            renderFeatureCallback={() => this.renderEdit(key)}
                            renderDefaultCallback={() => this.checkEditRender(key)}
                          />

                          {key.description &&
                            <button
                              className={`btn--expand ${this.state.showDetails.indexOf(key.sid) > -1 ? 'expanded' : ''}`}
                              title={translation.enrollments}
                              onClick={() => this.toggleDetails(key.sid)}
                            >
                              <span className="meta">{translation.details}</span>
                            </button>
                          }
                        </div>
                      </td>
                      <td aria-labelledby="heading-amount" className="number">
                        {key.units === '$' &&
                          `${currencyFormatter.format(key.amount, {code: key.currency})} ${key.currency}`
                        }
                        {key.units === '%' &&
                          `${key.amount}%`
                        }
                      </td>
                      <td aria-labelledby="heading-applies">{key.appliesTo}</td>
                      <td aria-labelledby="heading-starts" className="number">
                        {moment.utc(key.effectiveDate).tz(userTimezone).format('M/D/YYYY [at] h:mma z')}
                      </td>
                      <td aria-labelledby="heading-ends" className="number">
                        {moment.utc(key.expirationDate).tz(userTimezone).format('M/D/YYYY [at] h:mma z')}
                      </td>
                    </tr>,
                    <tr className={`
                      row-collapsed
                      ${this.state.showDetails.indexOf(key.sid) > -1 ? 'expanded' : ''}
                    `}>
                      <td colSpan="6">
                        <table>
                          <tbody>
                            <tr>
                              <td aria-labelledby="heading-details" className="body">{key.description}</td>
                            </tr>
                          </tbody>
                        </table>
                      </td>
                    </tr>
                  ])
                }
              )}
            </tbody>
          </table>
        )
      }

      return null;
    }

    return null;
  }
})

export default translate('FundingRulesList')(FundingRulesList);



// WEBPACK FOOTER //
// ./src/app/components/FundingRules/FundingRulesList.js